import { FACEBOOK_URL, INSTAGRAM_URL, YOUTUBE_URL } from '../utils/constants'
import './Home.css'

const Contact = () => {
    return (
        <div className="home">
            <div className="hero-background"></div>

            <section className="hero">
                <div className="container">
                    <div className="hero-content">
                        <h1 className="animate-slideUp stagger-1">
                            Contact <span className="text-gradient">NAH44</span>
                        </h1>
                        <p className="hero-subtitle animate-slideUp stagger-2">
                            We're here to help you revolutionize your vehicle's safety and your business's digital presence. reach out to us for support, inquiries, or partnerships.
                        </p>
                    </div>
                </div>
            </section>

            <section className="features">
                <div className="container">
                    <div className="features-grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '2rem' }}>
                        <div className="feature-card glass-card">
                            <div className="icon-wrapper">📧</div>
                            <h3>Email Support</h3>
                            <p>For technical assistance, bug reports, or general questions about our QR tags and dashboard.</p>
                            <p><strong>support@nah44.com</strong></p>
                            <p><small>Response time: Within 24 hours</small></p>
                        </div>

                        <div className="feature-card glass-card">
                            <div className="icon-wrapper">💼</div>
                            <h3>Business & Sales</h3>
                            <p>Interested in our Franchise Management solutions or QR Menu Ordering systems for your restaurant?</p>
                            <p><strong>sales@nah44.com</strong></p>
                            <p><small>Available: Mon - Sat, 10 AM - 7 PM</small></p>
                        </div>

                        <div className="feature-card glass-card">
                            <div className="icon-wrapper">📱</div>
                            <h3>Follow NAH44</h3>
                            <p>Stay updated on product launches, safety tips, and community stories.</p>
                            <p style={{ marginTop: '1rem' }}>
                                <a href={FACEBOOK_URL} target="_blank" rel="noopener noreferrer" style={{ color: 'var(--primary-light)', marginRight: '1.5rem' }}>
                                    Facebook
                                </a>
                                <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" style={{ color: 'var(--primary-light)', marginRight: '1.5rem' }}>
                                    Instagram
                                </a>
                                <a href={YOUTUBE_URL} target="_blank" rel="noopener noreferrer" style={{ color: 'var(--primary-light)' }}>
                                    YouTube
                                </a>
                            </p>
                        </div>

                        <div className="feature-card glass-card">
                            <div className="icon-wrapper">📍</div>
                            <h3>Headquarters</h3>
                            <p>NAH44 Platforms Pvt Ltd</p>
                            <address style={{ fontStyle: 'normal', color: 'var(--text-secondary)' }}>
                                Plot No. 68WP, Badangpet<br />
                                Maruthi Nagar, Balapur<br />
                                Hyderabad, Telangana - 500058
                            </address>
                            <p><strong>+91 78423 05029</strong></p>
                        </div>
                    </div>

                    <div className="glass-card" style={{ marginTop: '4rem', padding: '3rem' }}>
                        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
                            <h2 className="text-center mb-4">Send us a Message</h2>
                            <form style={{ display: 'grid', gap: '1.5rem' }} onSubmit={(e) => e.preventDefault()}>
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.5rem' }}>
                                    <div className="form-group">
                                        <label style={{ display: 'block', marginBottom: '0.5rem', color: 'white' }}>Full Name</label>
                                        <input type="text" placeholder="John Doe" style={{ width: '100%', padding: '0.8rem', borderRadius: '8px', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', color: 'white' }} />
                                    </div>
                                    <div className="form-group">
                                        <label style={{ display: 'block', marginBottom: '0.5rem', color: 'white' }}>Email Address</label>
                                        <input type="email" placeholder="john@example.com" style={{ width: '100%', padding: '0.8rem', borderRadius: '8px', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', color: 'white' }} />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label style={{ display: 'block', marginBottom: '0.5rem', color: 'white' }}>Subject</label>
                                    <select style={{ width: '100%', padding: '0.8rem', borderRadius: '8px', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', color: 'white' }}>
                                        <option>Technical Support</option>
                                        <option>Product Inquiry</option>
                                        <option>Franchise Partnership</option>
                                        <option>Billing Issue</option>
                                    </select>
                                </div>
                                <div className="form-group">
                                    <label style={{ display: 'block', marginBottom: '0.5rem', color: 'white' }}>Message</label>
                                    <textarea rows="5" placeholder="How can we help you?" style={{ width: '100%', padding: '0.8rem', borderRadius: '8px', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', color: 'white' }}></textarea>
                                </div>
                                <button className="btn-primary" style={{ padding: '1rem', width: '100%' }}>Send Message</button>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Contact
